import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";
import { Auth } from "aws-amplify";

import GoogleImage from "assets/images/socialAuth/Google.png";
import { RoleUser, SOCIAL_AUTH_PROVIDERS } from "interfaces/interfaces";

import { SocialAuthButton, SocialAuthWrapper } from "./styles";

const socialAuthImages = {
  Google: GoogleImage
};

export const SocialAuth: FC<{
  children?: never;
  userRole?: RoleUser;
}> = ({ userRole }) => {
  const { t } = useTranslation("login");

  const handleSocialAuthClick = async (
    provider: CognitoHostedUIIdentityProvider
  ) => {
    // customState value type: TCustomOAuthState
    await Auth.federatedSignIn({
      provider: provider,
      customState: userRole ?? "login"
    });
  };

  return (
    <SocialAuthWrapper $m={!userRole ? "0 0 24px" : 0}>
      {SOCIAL_AUTH_PROVIDERS.map((p) => (
        <SocialAuthButton
          key={p}
          icon={<img src={socialAuthImages[p]} alt="" />}
          className="socialAuthButton"
          onClick={() => handleSocialAuthClick(p)}
          styles={{
            icon: {
              position: "absolute",
              top: "50%",
              left: "1rem",
              transform: "translateY(-50%)"
            }
          }}
        >
          {userRole
            ? t(`register.registerWith.${p}`)
            : t(`register.loginWith.${p}`)}
        </SocialAuthButton>
      ))}
    </SocialAuthWrapper>
  );
};
